import { useEffect, useMemo, useState } from "react";

import ZvCreate from "./ZvCreate";
import ZvUpdate from "./ZvUpdate";
import GeneralTable from "../Tabellen/GeneralTable";
import DatenLaden from "../Tabellen/DatenLaden";
import InformationCell from "../Tabellen/InformationCell";
import { zvHeader } from "../Tabellen/ConstTabKopf/ZweckverbandKopf";
import StammdatenExport from "../Stammdaten/StammdatenExport";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";


export default function ZvLaden({ instance, setTable, goBack }) {
    const [data, setData] = useState(null);
    const [columns, setColumns] = useState(null);

    useEffect(() => {
        let opts = { 'onlyActive': false };
        instance.getZweckverbandZweckverbandGet(opts, (error, data, response) => {
            if (error) {
                console.error(error);
                FehlerauswertungErrResp(error, response);
            } else {
                setData(data);
                setColumns(zvHeader);
            }
        });
    }, [instance])

    const reloadData = () => {
        setData();
        let opts = { 'onlyActive': false };
        let loading = new Promise((result) => {
            instance.getZweckverbandZweckverbandGet(opts, (error, data, response) => {
                if (error) {
                    console.error(error);
                    FehlerauswertungErrResp(error, response);
                } else {
                    result(data);
                }
            });
        })
        loading.then(d => setData(d));
    }
    const prepData = useMemo(() => data, [data]);
    const updateCol =
    {
        id: "update",
        Header: "",
        keyword: "Änderungen",
        Cell: ({ row }) => (
            <div>
                <ZvUpdate rowEntry={row} instance={instance} reloadData={reloadData} />
            </div>
        )
    }
    const commCol = {
        id: "comment",
        Header: "",
        keyword: "Info",
        Cell: ({ row }) => (
            <div>
                <InformationCell comment={row.original.kommentar} />
            </div>
        )
    }

    const csvIt = loadedData => {
        return loadedData.map(it =>
        ({
            ...it,
            Zweckverband: it.name,
            Abkürzung: it.kurz,
            Kommentar: it.kommentar
        }))
    }

    return (
        <>
            <ZvCreate instance={instance} reloadData={reloadData} />
            {data && columns
                ? <div>
                    <GeneralTable data={prepData} columns={columns} hiddenColumns={['id']} additionalColumns={[commCol, updateCol]} reloadData={reloadData} />
                    <StammdatenExport csvedData={csvIt(prepData)} csvHeader={['Zweckverband', 'Abkürzung', 'Kommentar']} csvFilename={"sd_zv"} />
                </div>
                : <DatenLaden />}
        </>
    );
}